export default __webpack_public_path__ + "static/media/video_wine.12976a8c.svg";